module.exports = __webpack_public_path__ + "static/projekt-opakowania-slim-079a85c3d8bf6e4b940f1eb89054fd69.png";